module.exports = __webpack_public_path__ + "media/PAG72-04.1619d6ac.mp3";